/* <sticky-buy-bar> — fixed add-to-cart bar that appears once the buy buttons
   scroll out of view. The bar's submit button targets the main product form via
   its form attribute, so add-to-cart mechanics stay with product-form. */
if (!customElements.get('sticky-buy-bar')) {
  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      const productInfo = this.closest('product-info');
      this.anchor = productInfo && productInfo.querySelector('.product-form__buttons');
      if (!this.anchor || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(
        ([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.classList.toggle('is-visible', passed);
        },
        { threshold: 0 }
      );
      this.observer.observe(this.anchor);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('sticky-buy-bar', StickyBuyBar);
}
